import { object } from 'common/helpers'


export const initialState = {
  location: {
    pathname: null,
    search: null,
    query: {},
  },
}

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case '@@router/LOCATION_CHANGE': {
      const query = {}

      if (payload.location && payload.location.search) {
        payload.location.search
          .replace(/^\?/, '')
          .split('&')
          .forEach((queryString) => {
            const key   = queryString.replace(/=.*/, '')
            const value = decodeURIComponent(queryString.replace(/.*=/, ''))

            try {
              query[key] = JSON.parse(value)
            }
            catch (e) {
              query[key] = value
            }
          })
      }

      return object.setIn(payload, [ 'location', 'query' ], query)
    }
    default:
      return state
  }
}
